var map = {
	"./1.jpg": 7061,
	"./1.png": 25,
	"./2.jpg": 4775,
	"./2.png": 9686,
	"./3.jpg": 1378,
	"./3.png": 7684,
	"./4.jpg": 5590,
	"./4.png": 2204,
	"./5.jpg": 5691,
	"./5.png": 6896,
	"./6.jpg": 1065,
	"./7.jpg": 73,
	"./8.jpg": 2027,
	"./pic1.jpg": 9118,
	"./pic11.jpg": 6498,
	"./pic2.jpg": 7364,
	"./pic22.jpg": 7454,
	"./pic3.jpg": 8619,
	"./pic33.jpg": 7916,
	"./pic4.jpg": 1893,
	"./pic44.jpg": 3171,
	"./pic5.jpg": 2756
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2210;